// 쿠키값 저장
const setCookie = (name, value, days) => {
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    var expires = "; expires=" + date.toGMTString();
  } else {
    var expires = "";
  }

  document.cookie = name + "=" + value + expires + "; path=/";
};

// 쿠키값 가져오기
const getCookieValue = (key) => {
  let cookieKey = key + "=";
  let result = "";
  const cookieArr = decodeURIComponent(document.cookie).split(";");

  for (let i = 0; i < cookieArr.length; i++) {
    if (cookieArr[i][0] === " ") {
      cookieArr[i] = cookieArr[i].substring(1);
    }

    if (cookieArr[i].indexOf(cookieKey) === 0) {
      result = cookieArr[i].slice(cookieKey.length, cookieArr[i].length);
      return result;
    }
  }
  return result;
};

module.exports = {
  setCookie,
  getCookieValue,
};
